import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { AdContainer } from "@/ads/components/AdContainer";
import { useRefsContext } from "@/contexts/ref";
import { useI18n } from "@/shared/hooks";
import { AdSlotIds } from "@/shared/types";
import { Card, Divider } from "@gemini/ui";
import { PartnerBoxWrapper } from "./PartnerBoxWrapper";
import { useShowAds } from "../../hooks/useShowAds";
export const PartnerBoxServices = () => {
    const { t } = useI18n();
    const { PartnerBoxServicesRef } = useRefsContext();
    const { isAllSlotsLoaded, showSection } = useShowAds();
    const showDivider1 = isAllSlotsLoaded([
        AdSlotIds.PARTNERBOX_3_TOOLS_AND_SERVICE,
        AdSlotIds.PARTNERBOX_4_TOOLS_AND_SERVICE,
    ]);
    const showDivider2 = isAllSlotsLoaded([
        AdSlotIds.PARTNERBOX_4_TOOLS_AND_SERVICE,
        AdSlotIds.PARTNERBOX_5_TOOLS_AND_SERVICE,
    ]);
    return (_jsx(_Fragment, { children: _jsx(PartnerBoxWrapper
        // @ts-ignore
        , { 
            // @ts-ignore
            partnerBoxRef: PartnerBoxServicesRef, title: t("advertising.partner_services.headline_two"), display: showSection([
                AdSlotIds.PARTNERBOX_3_TOOLS_AND_SERVICE,
                AdSlotIds.PARTNERBOX_4_TOOLS_AND_SERVICE,
                AdSlotIds.PARTNERBOX_5_TOOLS_AND_SERVICE,
            ])
                ? "block"
                : "none", children: _jsxs(Card, { borderRadius: "8", hasPadding: false, children: [_jsx(AdContainer, { adSlotId: AdSlotIds.PARTNERBOX_3_TOOLS_AND_SERVICE, width: "100%", height: "min-content" }), showDivider1 && _jsx(Divider, {}), _jsx(AdContainer, { adSlotId: AdSlotIds.PARTNERBOX_4_TOOLS_AND_SERVICE, width: "100%", height: "min-content" }), showDivider2 && _jsx(Divider, {}), _jsx(AdContainer, { adSlotId: AdSlotIds.PARTNERBOX_5_TOOLS_AND_SERVICE, width: "100%", height: "min-content" })] }) }) }));
};
